// @ts-ignore
import skRows from 'src/i18n/texts/languages/sk.csv'
// @ts-ignore
import enRows from 'src/i18n/texts/languages/en.csv'
// @ts-ignore
import csRows from 'src/i18n/texts/languages/cs.csv'
// @ts-ignore
import ukRows from 'src/i18n/texts/languages/uk.csv'
// @ts-ignore
import plRows from 'src/i18n/texts/languages/pl.csv'
// @ts-ignore
import huRows from 'src/i18n/texts/languages/hu.csv'
// @ts-ignore
import roRows from 'src/i18n/texts/languages/ro.csv'
// @ts-ignore
import itRows from 'src/i18n/texts/languages/it.csv'
// @ts-ignore
import deRows from 'src/i18n/texts/languages/de.csv'
import { createMessageSource } from 'src/i18n/lib/texts/createMessageSource'
import { languageToLocale } from 'src/i18n/locale'

const normalizeRows = (rows: any[]): { key: string; value: string }[] =>
    rows
        .map(row =>
            Array.isArray(row)
                ? { key: row[0], value: row[1] }
                : { key: row.key, value: row.value }
        )
        .filter(row => row.key && row.key !== 'key')

const languageRows: Record<string, { key: string; value: string }[]> = {
    sk: normalizeRows(skRows),
    en: normalizeRows(enRows),
    cs: normalizeRows(csRows),
    uk: normalizeRows(ukRows),
    pl: normalizeRows(plRows),
    hu: normalizeRows(huRows),
    ro: normalizeRows(roRows),
    it: normalizeRows(itRows),
    de: normalizeRows(deRows)
}

const rows = languageRows.sk.map(({ key }) => ({
    key,
    ...Object.fromEntries(
        Object.entries(languageRows).map(([language, translations]) => [
            language,
            translations.find(row => row.key === key)?.value
        ])
    )
}))

export const messagesSource = createMessageSource(
    rows,
    Object.keys(languageToLocale).map((key: string) => key.toLowerCase())
)
